module.exports = __webpack_public_path__ + "static/img/mobile_help5.b449ef6c.png";